<template>
  <div :class="classes">
    <div v-if="content.title" class="c-label__title" v-html="content.title" />
    <div v-if="content.text" class="c-label__text" v-html="content.text" />
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-label",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-label {
  color: #000;
  padding: 1.5rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @include media-breakpoint-down(xl) {
    padding: 1.25rem;
  }
  @include media-breakpoint-down(lg) {
    padding: 1rem;
  }

  &__title {
    font-weight: bold;
    font-size: 1.5rem;

    @include media-breakpoint-down(xl) {
      font-size: 1.25rem;
    }

    @include media-breakpoint-down(lg) {
      font-size: 1rem;
    }
  }
  &__text {
    font-size: 1.125rem;
    margin: 1rem 0 0;

    @include media-breakpoint-down(xl) {
      font-size: 1rem;
      margin: 0.75rem 0 0;
    }

    @include media-breakpoint-down(lg) {
      font-size: 0.875rem;
      margin: 0.5rem 0 0;
    }
  }
  &--small {
    padding: 1.25rem;

    @include media-breakpoint-down(xl) {
      padding: 1rem;
    }
    @include media-breakpoint-down(lg) {
      padding: 0.75rem;
    }
  }
  &--compact &__title {
    font-size: 1.125rem;

    @include media-breakpoint-down(xl) {
      font-size: 1rem;
    }

    @include media-breakpoint-down(lg) {
      font-size: 0.875rem;
    }
  }
  ::v-deep {
    b {
      font-weight: bold;
    }
  }
}
</style>
